import { Text } from 'foundations-components/components/Text';
import MdxHeader from './MdxHeader';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledH3 = props => /*#__PURE__*/_jsx(Text, Object.assign({}, props, {
  as: "h3"
}));
function MdxH3(props) {
  const {
    children
  } = props;
  return /*#__PURE__*/_jsx(MdxHeader, {
    Component: StyledH3,
    marginBlockStart: "1100",
    marginBlockEnd: "400",
    children: children
  });
}
export default MdxH3;